// 导入封装好的网络请求类工具
import Network from './network';

// 封装各种接口请求
// export const 接口名 = () => Network.get('/路由',参数对象);

export default {
	UserLogin: (argdata) => Network.post('/api/UserInfo/Login_Web', argdata),
	CheckUserauth: (argdata) => Network.get('/api/userinfo/checktoken', argdata),
	UserLogout: (argdata) => Network.get('/api/UserInfo/Logout', argdata),
	GetFuns: (argdata) => Network.get('/api/SysFun/GetUserFunTree', argdata),

	// 首页
	GetDashboardSummary: (argdata) => Network.get('/api/Dashboard/Summary', argdata),
	// 获取今日巡检记录
	GetTodayPatrolLogs: (argdata) => Network.get('/api/Dashboard/TodayPatrolLogs', argdata),

	// 组织、用户管理
	GetHoldList: (argdata) => Network.post('/api/HoldInfo/GetHoldList', argdata),
	LoadParentBase: (argdata) => Network.get('/api/HoldInfo/LoadParentBase', argdata),
	GetHoldTree: (argdata) => Network.get('/api/HoldInfo/GetHoldTree', argdata),
	SaveHoldInfo: (argdata) => Network.post('/api/HoldInfo/SaveHoldInfo', argdata),
	GetHoldDetail: (argdata) => Network.get('/api/HoldInfo/Detail', argdata),
	RemoveHold: (argdata) => Network.post('/api/HoldInfo/RemoveHold', argdata),
	// 新增/修改账号
	SaveAccount: (argdata) => Network.post('/api/HoldInfo/SaveAccount', argdata),
	// 重置账号密码
	ChangeUserPassword: (argdata) => Network.post('/api/HoldInfo/ChangeUserPassword', argdata),

	// 设备管理
	SearchDeviceList: (argdata) => Network.post('/api/DeviceInfo/SearchDeviceList', argdata),
	SaveDeviceInfo: (argdata) => Network.post('/api/DeviceInfo/SaveDeviceInfo', argdata),
	RemoveDevice: (argdata) => Network.post('/api/DeviceInfo/RemoveDevice', argdata),
	GetSingleDeviceDetail: (argdata) => Network.get('/api/DeviceInfo/Detail', argdata),
	// 批量导入设备，SN列表
	ImportDeviceBySNList: (argdata) => Network.post('/api/DeviceInfo/ImportDeviceBySNList', argdata),
	// 批量导入设备，Excel文档
	ImportDeviceByExcel: (argdata) => Network.post('/api/DeviceInfo/ImportDeviceByExcel', argdata),

	// 巡检点管理
	SearchPatrolCardList: (argdata) => Network.post('/api/PatrolCard/SearchList', argdata),
	SavePatrolCardInfo: (argdata) => Network.post('/api/PatrolCard/SaveInfo', argdata),
	GetPatrolCardDetail: (argdata) => Network.get('/api/PatrolCard/GetDetail', argdata),
	RemovePatrolCardInfo: (argdata) => Network.post('/api/PatrolCard/RemoveInfo', argdata),
	GetCardOptions: (argdata) => Network.get('/api/PatrolCard/GetCardOptions', argdata),

	// 员工管理
	SearchStaffList: (argdata) => Network.post('/api/StaffInfo/SearchList', argdata),
	SaveStaffInfo: (argdata) => Network.post('/api/StaffInfo/SaveStaffInfo', argdata),
	GetStaffDetail: (argdata) => Network.get('/api/StaffInfo/Detail', argdata),
	GetAccountOptions: (argdata) => Network.get('/api/StaffInfo/GetAccountOptions', argdata),

	// 巡更路线
	GetPatrolRoadList: (argdata) => Network.post('/api/PatrolRoad/List', argdata),
	GetPatrolDetail: (argdata) => Network.get('/api/PatrolRoad/Detail', argdata),
	SaveRoadInfo: (argdata) => Network.post('/api/PatrolRoad/SaveRoadInfo', argdata),
	GetBindAccounts: (argdata) => Network.get('/api/PatrolRoad/GetBindAccounts', argdata),
	GetBindCards: (argdata) => Network.get('/api/PatrolRoad/GetBindCards', argdata),

	// 巡检打卡记录
	GetPatrolClockInList: (argdata) => Network.post('/api/PatrolLog/List', argdata),
	ExportPatrolClockInList: (argdata) => Network.post('/api/PatrolLog/List_Export', argdata),

	SaveProductType: (argdata) => Network.post('/api/ProductType/save', argdata),
	GetProductTypeList: (argdata) => Network.get('/api/ProductType/list', argdata),
	GetProductTypeDetail: (argdata) => Network.get('/api/ProductType/detail', argdata),
	DeleteProductType: (argdata) => Network.post('/api/ProductType/delete', argdata),
	SaveProductInfo: (argdata) => Network.post('/api/ProductInfo/save', argdata),
	GetProductInfoList: (argdata) => Network.get('/api/ProductInfo/list', argdata),
	GetProductInfoDetail: (argdata) => Network.get('/api/ProductInfo/detail', argdata),
	DeleteProductInfo: (argdata) => Network.post('/api/ProductInfo/delete', argdata),

	SaveReceiptOrder: (argdata) => Network.post('/api/ReceiptOrder/Save', argdata),
	GetReceiptOrderDetail: (argdata) => Network.get('/api/ReceiptOrder/detail', argdata),
	GetReceiptOrderList: (argdata) => Network.get('/api/ReceiptOrder/list', argdata),
	ApprovalReceiptOrder: (argdata) => Network.post('/api/ReceiptOrder/approval', argdata),
	// 读取图片文件
	ReadImage: (argdata) => Network.get('/api/upload/read_image', argdata),

	// 斗车铲料
	SaveForkRawMaterial: (argdata) => Network.post('/api/ForkRawMaterial/Save', argdata),
	GetForkRawMaterialDetail: (argdata) => Network.get('/api/ForkRawMaterial/detail', argdata),
	GetForkRawMaterialList: (argdata) => Network.get('/api/ForkRawMaterial/list', argdata),
	ApprovalForkRawMaterial: (argdata) => Network.post('/api/ForkRawMaterial/approval', argdata),

	GetProductItemOptions: (argdata) => Network.get('/api/ProductInfo/options', argdata),
	GetSupplierItemOptions: (argdata) => Network.get('/api/SupplierInfo/options', argdata),

	// 生产管理
	GetManuactureList: (argdata) => Network.post('/api/Manuacture/ListTable', argdata),
	AddManuactureTask: (argdata) => Network.post('/api/Manuacture/AddTask', argdata),
	GetManuactureDetail: (argdata) => Network.get('/api/Manuacture/GetDetail', argdata),

	// 字典表，添加
	AddDict: (argdata) => Network.post('/api/Dictionary/AddDict', argdata),
	GetDictList: (argdata) => Network.get('/api/Dictionary/list', argdata),
	DeleteDict: (argdata) => Network.post('/api/Dictionary/DeleteDict', argdata),

	// 财务管理
	// 添加项目、项目列表
	NewProject: (argdata) => Network.post('/api/ProjectInfo/NewProject', argdata),
	GetProjectList: (argdata) => Network.get('/api/ProjectInfo/GetOptions', argdata),
	//收入明细表
	AddFinanceIncomeOrder: (argdata) => Network.post('/api/FinanceIncome/Add', argdata),
	ModifyFinanceIncomeOrder: (argdata) => Network.post('/api/FinanceIncome/Modify', argdata),
	GetFinanceIncomeList: (argdata) => Network.get('/api/FinanceIncome/List', argdata),
	GetFinanceIncomeDetail: (argdata) => Network.get('/api/FinanceIncome/Detail', argdata),
	RemoveFinanceIncome: (argdata) => Network.post('/api/FinanceIncome/RemoveIncomeInfo', argdata),
	//搜索收入明细列表（新）
	SearchFinanceIncomeList: (argdata) => Network.post('/api/FinanceIncome/SearchList', argdata),
	//导出收入明细列表数据
	ExportFinanceIncomeList: (argdata) => Network.post('/api/FinanceIncome/ExportList', argdata),
	//支出明细表
	AddExpenditureInfo: (argdata) => Network.post('/api/Expenditure/Add', argdata),
	ModifyExpenditureInfo: (argdata) => Network.post('/api/Expenditure/Modify', argdata),
	SearchExpenditureList: (argdata) => Network.post('/api/Expenditure/SearchList', argdata),
	ExportExpenditureList: (argdata) => Network.post('/api/Expenditure/ExportList', argdata),
	GetExpenditureDetail: (argdata) => Network.get('/api/Expenditure/Detail', argdata),

	// 日志列表
	GetSysLogsList: (argdata) => Network.post('/api/SysLogs/List', argdata),

	// 巡检记录
	GetPatrolDataRecords: (argdata) => Network.post('/api/PatrolData/Records', argdata),
	// 导出巡检记录
	ExportPatrolDataRecords: (argdata) => Network.post('/api/PatrolData/ExportRecords', argdata),
	// 巡检统计（按巡检点）
	TotalByPatrolCard: (argdata) => Network.post('/api/PatrolData/TotalByPatrolCard', argdata),

	// 线路管理
	GetRoadInfoList: (argdata) => Network.post('/api/RoadInfo/List', argdata),
	GetRoadDetail: (argdata) => Network.get('/api/RoadInfo/GetDetail', argdata),
	SaveRoadInfoNew: (argdata) => Network.post('/api/RoadInfo/Save', argdata),
	RemoveRoadInfo: (argdata) => Network.post('/api/RoadInfo/Remove', argdata),

	// 任务计划管理
	GetRoadTaskList: (argdata) => Network.post('/api/RoadTask/List', argdata),
	GetRoadTaskDetail: (argdata) => Network.get('/api/RoadTask/Detail', argdata),
	SaveRoadTask: (argdata) => Network.post('/api/RoadTask/Save', argdata),
	RemoveRoadTask: (argdata) => Network.post('/api/RoadTask/Remove', argdata),

	GetRoadOptions: (argdata) => Network.get('/api/RoadInfo/Options', argdata),
	GetDeviceOptions: (argdata) => Network.get('/api/RoadTask/DeviceOptions', argdata)
}